import axios from 'axios';
import { interceptorResponse, interceptorError } from '@/helpers/interceptorResponse';
import { LOCAL_STORAGE_ACCESS_TOKEN } from '@/helpers/local_storage_constants';

class API {

  async configureTelemetric() {
    const api = axios.create({
      baseURL: `${process.env.VUE_APP_API_BASE_REST_TELEMETRIC}`,
      timeout: 60000
    });
    api.interceptors.request.use(this.authInterceptor);
    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );
    return api;
  }

  authInterceptor(config) {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_TOKEN);
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  }

}

export default API;